module.exports = __webpack_public_path__ + "img/title-bg.8de7c0c3.png";